import cn from 'classnames'

import '../Loading/styles.css'

interface Props {
  className?: string
  disabled?: boolean
  error?: string
  isRequired?: boolean
  label?: string
  onChange: any
  options: any
  value: any
  name?: string
  tooltip?: string
  inputStyle?: string
  labelStyle?: string
  isLoading?: boolean
  [key: string]: any
}

const InputSelect = ({
  className,
  disabled,
  error,
  isRequired,
  label,
  onChange,
  options,
  value,
  name,
  inputStyle,
  labelStyle,
  isLoading,
}: Props) => {
  const handleOnChange = (e: any) => {
    onChange(e.target.value)
  }

  return (
    <div
      className={cn(
        'pmui-input-select-wrapper pmui-mt-0 pmui-mb-2 pmui-w-full',
        className,
      )}
    >
      {label && (
        <div
          className={cn(
            'pmui-text-sm pmui-font-semibold pmui-mb-2',
            { 'pmui-text-pop-gray-200': !error },
            { 'pmui-text-red-500': error },
            labelStyle,
          )}
        >
          {label}
          {isRequired && (
            <span className="pmui-text-red-500 pmui-text-sm"> *</span>
          )}
        </div>
      )}
      <div className="pmui-w-full">
        <select
          name={name}
          disabled={disabled}
          className={cn(
            'input-select pmui-bg-white focus:pmui-outline-none pmui-h-12',
            'pmui-py-3 pmui-px-4 pmui-border pmui-w-full pmui-text-xs',
            {
              'focus:pmui-ring-pop-orange': !error,
              'focus:pmui-border-pop-orange': !error,
              'focus:pmui-border-red-500': !!error,
              'focus:pmui-ring-red-500': !!error,
              'pmui-border-pop-gray-200': !error,
              'pmui-border-red-500': !!error,
              'pmui-text-pop-gray-200': value === 'DEFAULT',
            },
            inputStyle,
          )}
          value={value}
          onChange={handleOnChange}
        >
          {options.map(({ disabled, value, text }: any) => (
            <option
              key={text}
              disabled={disabled}
              value={value}
              className="pmui-text-sm"
            >
              {text}
            </option>
          ))}
        </select>

        <div
          className={cn(
            {
              'loading-indicator pmui-h-6 pmui-w-6 pmui-animate-spin pmui-absolute pmui-top-1/2 pmui-right-4':
                isLoading && disabled,
            },
            { 'chevron bottom': !disabled || !isLoading },
          )}
        />
      </div>
      {error && (
        <p className="pmui-text-sm pmui-text-red-500 pmui-mt-2">{error}</p>
      )}
    </div>
  )
}

export default InputSelect
